import {RegexpValidator} from "./RegexpValidator";

export class EmailValidator extends RegexpValidator{

    protected getRegexp(): RegExp {
        return /\S+@\S+\.\S+/;
    }
}